<template>
  <TextFieldWithIconGroup
    v-model="inputValue"
    innerIconType="phoneNumber"
    type="tel"
    :placeholder="placeholder"
    :label="label"
    :appLabelText="appLabelText"
    :validation-state="validationState"
    :disabled="disabled"
    @blur="onBlur"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import Cleave from "cleave.js";
import "cleave.js/dist/addons/cleave-phone.jp";
import TextFieldWithIconGroup from "@/components/molecules/form/TextFieldWithIconGroup.vue";
import { ValidationStateType } from "@/types/Validation";

type CleaveInput = {
  target: {
    name: string;
    // 整形済みの値
    value: string;
    // 整形前の値
    rawValue: string;
  };
};

@Component({
  components: {
    TextFieldWithIconGroup
  }
})
export default class PhoneNumberInputGroup extends Vue {
  @Prop({
    type: String,
    required: true,
    default: ""
  })
  value!: string;

  @Prop({
    type: String,
    default: "携帯電話番号"
  })
  placeholder!: string;

  @Prop({
    type: String,
    default: ""
  })
  label!: string;

  @Prop({
    type: String,
    default: ""
  })
  appLabelText!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop({
    type: Object,
    default: () => ({})
  })
  validationState!: ValidationStateType;

  inputValue = "";
  cleave: Cleave | null = null;

  @Watch("value")
  renewInputValue() {
    this.formatPhoneNumber();
  }

  mounted() {
    this.inputValue = this.value;
    this.formatPhoneNumber();
  }

  formatPhoneNumber() {
    const input = this.$el.querySelector("input")!;
    this.cleave = new Cleave(input, {
      phone: true,
      phoneRegionCode: "jp",
      onValueChanged: this.onValueChanged.bind(this)
    });
    this.cleave.setRawValue(this.value);
  }

  onValueChanged({ target }: CleaveInput) {
    this.inputValue = target.value;
    this.$emit("input", target.rawValue);
    if (this.disabled) {
      return;
    }
    this.validationState?.handleChange(target.rawValue, false);
  }

  onBlur($event: Event) {
    this.$emit("blur");
    if (this.disabled) {
      return;
    }
    this.validationState?.handleBlur($event);
  }

  beforeUnmount() {
    if (this.cleave) {
      this.cleave.destroy();
      this.cleave = null;
    }
  }
}
</script>
